<div class="card-container">
    <div class="page-title">
        <i class="fas fa-exclamation"></i>
        <kendo-label class="title-table-style" text="404 Error"></kendo-label>
    </div>
    <div class="card-component">
        <hr />
        <h2>404: Page not found: {{ path }}</h2>
    </div>
</div>
